<!--
 * A common file which will give form feild based on passed parameter
 * 1. Input with type
 * 2. Select box
-->

<template>
  <div v-show="!hide">
    <!-- Input Start -->
    <div class="input_container" v-if="isFieldText">
      <weex-text class="input_label" v-html="getFieldLabelToShow"></weex-text>

      <input
          :disabled="disabled"
          class="input_with_border_bottom"
          :value="getFieldValue"
          @input="onInputValueEntered($event.target.value)"
          :type="getInputType"/>

      <field-error-item
          :show-error="showFieldError"
          :error-msg="getErrorMessage"
      ></field-error-item>

    </div>
    <!-- Input End -->


    <!-- file attach start   -->
    <div v-if="isFieldFileUpload" class="input_container">
      <file-attach-button
          class="horizontal-center"
          size="full"
          :file-attach-button-id="fieldKey"
          :disabled="disabled"
          :show-attach-description="showFieldError"
          :attach-description="getErrorMessage"
          :text="getFieldLabelToShow"
          :attach-image-des-src="documentAttachImage"
          @filesAttached="onFileAttached($event.files[0])"
      ></file-attach-button>
    </div>
    <!-- file attach end   -->


    <!--Select box start -->
    <div class="dropdown-container" v-show="isFieldDropDown">
      <wxc-dropdown
          :title="getFieldLabelToShow"
          default-item="Select"
          :config="dropdownConfig"
          :disabled="disabled"
          :select-item="getSelectedDropDownValue"
          :list="dropDownList"
          :hide-additional-details="true"
          @onItemSelected="onDropDownSelected($event.value)"
      ></wxc-dropdown>

      <field-error-item
          :show-error="showFieldError"
          :error-msg="getErrorMessage"
      ></field-error-item>
    </div>
    <!--Select box end -->

  </div>
</template>
<script>
import WxcDropdown from "../../../weex-ui/packages/wxc-dropdown";
import { DefaultResourceConfig, ImageResourcesUtil } from "@/utils/ImageResourcesUtil";
import {Constants} from "@/components/Constants";
import EzUtils from "@/utils/EzUtils";
import FieldErrorItem from "@/components/layout/FieldErrorItem";
import FileAttachButton from "@/components/layout/FileAttachButton";

export default {
  name: "FormWidgetProvider",
  components: {WxcDropdown, FieldErrorItem, FileAttachButton},

  data: () => ({
    userInputEdited: false,
    userInputValue: "",
    dropDownSelectedValue: "",
    showFieldError: false,
    isMounted: false,
    calledDropDownSelectMethodManually: false,
  }),

  props: {
    fieldKey: {
      type: String,
      required: true,
      default: ""
    },

    fieldLabel: {
      type: String,
      required: true,
      default: ""
    },

    fieldValue: {
      type: String,
      required: true,
      default: ""
    },

    dropDownOptions: {
      type: Array,
      required: true,
      default: () => ([])
    },

    /***
     * Option will be one of   "DROPDOWN", "INTEGER","DECIMAL","DATE","STRING","BOOLEAN","FILE_UPLOAD"
     */
    inputType: {
      type: String,
      required: true,
      default: ""
    },

    validation: {
      type: String,
      required: true,
      default: ""
    },

    optional: {
      type: Boolean,
      required: true,
      default: false
    },

    disabled: {
      type: Boolean,
      required: true,
      default: false
    },

    hide: {
      type: Boolean,
      required: true,
      default: false
    },

    ignoreValue: {
      type: Boolean,
      required: true,
      default: true
    },

    errorMessage: {
      type: String,
      required: true,
      default: ""
    },

    allFormWidgetMounted: {
      type: Boolean,
      required: true,
      default: false
    },

    hackForDataChange: {
      type: Number,
      required: true,
      default: 0
    },

    inputMaxLength: {
      type: Number,
      required: true,
      default: -1
    },

    fileUploaded: {
      type: Boolean,
      required: true,
      default: false
    },

    fileUploadOnAttachment: {
      type: Boolean,
      required: true,
      default: false
    },
  },

  methods: {
    isIgnoreValue() {
      return this.ignoreValue;
    },

    isEnabled() {
      return !this.disabled;
    },

    isFieldWidgetDropDown() {
      return this.isFieldDropDown;
    },

    getValue() {
      return this.getFieldValue;
    },

    getLabel() {
      return this.getFieldLabel;
    },

    isNotValid(valid) {
      return !this.isValid();
    },

    isValid() {
      let valid = true;
      const value = this.getFieldValue;

      if (this.isFieldFileUpload) {
        if (this.isFileUploadedOrAttached) {
          valid = true;
        } else {
          valid = this.optional;
        }
      } else if (this.isFieldBoolean) {
        //TODO @Anish add validation
      } else {
        if (EzUtils.isEmpty(value)) {
          valid = this.optional;
        } else {
          valid = EzUtils.isEmpty(this.validation)
              || EzUtils.doesPatternMatch(this.validation, value);
        }
      }

      return valid;
    },

    showError() {
      this.showFieldError = true;
    },

    onFileAttached(file) {
      if (this.fileUploadOnAttachment) {
        this.$emit("onFileAttached", this.fieldKey, file);
      } else {
        this.onInputValueEntered(file);
      }
    },

    onFileUploaded(documentId) {
      this.onInputValueEntered(documentId);
    },

    onInputValueEntered(value) {
      this.userInputEdited = true;
      this.userInputValue = value; //do not remove this

      /* handling of input length constraint (start) */
      if (value && this.isFieldText && this.inputMaxLength && this.inputMaxLength > 0) {
        value = value.substr(0, this.inputMaxLength);
        this.userInputValue = value;
      }
      /*handling of input length constraint (end)*/

      if (this.isValid()) {
        this.showFieldError = false;
      }
    },

    onDropDownSelected(value) {
      this.dropDownSelectedValue = value;
      if (this.isFieldDropDown && this.isMounted) {
        this.onInputValueEntered(value);
        this.$emit("onDropDownSelected", this.fieldKey, value);
      }
    },

    isDropDownOptionIsValid(dropDownOption) {
      return dropDownOption
          && EzUtils.isNotEmpty(this.dropDownOptions)
          && this.dropDownOptions.includes(dropDownOption);
    }
  },

  computed: {
    getFieldLabelToShow() {
      let fieldLabel = this.getFieldLabel;
      if (!this.optional) {
        fieldLabel = fieldLabel + " *";
      }

      return fieldLabel;
    },

    getFieldLabel() {
      if (this.fieldLabel) {
        return this.fieldLabel;
      }
      return EzUtils.removeCharsAndJoinWithUpperCase(this.fieldKey, "_", "\\.")
    },

    getFieldValue() {
      return this.userInputEdited ? this.userInputValue : this.fieldValue;
    },

    getSelectedDropDownValue() {
      if (!this.dropDownOptions || this.dropDownOptions.length === 0) {
        return "";
      }
      let selectedValue = this.getFieldValue;
      if (selectedValue) {
        if (!this.dropDownOptions.includes(selectedValue)) {
          selectedValue = this.dropDownOptions[0];
        }
      } else {
        selectedValue = this.dropDownOptions[0];
      }

      return selectedValue;
    },

    getInputType() {
      let inputType = "text";
      if (this.inputType) {
        if (Constants.INTEGER === this.inputType || Constants.DECIMAL === this.inputType) {
          inputType = "number";
        } else if (Constants.DROPDOWN === this.inputType) {
          inputType = "select";
        }

        //TODO @anish add more input types like date, boolean
      }

      return inputType;
    },

    getErrorMessage() {
      if (this.isFieldFileUpload) {
        return "Please upload document";
      }

      return this.errorMessage;
    },

    isFieldText() {
      return Constants.STRING === this.inputType
          || Constants.INTEGER === this.inputType
          || Constants.DECIMAL === this.inputType;
    },

    isFieldDropDown() {
      return Constants.DROPDOWN === this.inputType;
    },

    isFieldDate() {
      return Constants.DATE === this.inputType;
    },

    isFieldFileUpload() {
      return Constants.FILE_UPLOAD === this.inputType;
    },

    isFieldBoolean() {
      return Constants.BOOLEAN === this.inputType;
    },

    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },

    dropDownList() {
      return this.dropDownOptions ? this.dropDownOptions : [];
    },

    isFileUploadedOrAttached() {
      let fileUploadedOrAttached = false;
      const value = this.getFieldValue;
      const numberConvertedValue = EzUtils.convertToNumber(this.getFieldValue);
      if (this.fileUploaded
          || EzUtils.isValidId(numberConvertedValue)
          || (!EzUtils.isValidNumber(numberConvertedValue) && value) // value is file
      ) {
        fileUploadedOrAttached = true;
      }

      return fileUploadedOrAttached;
    },

    documentAttachImage() {
      return this.isFileUploadedOrAttached
          ? ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN)
          : ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
    },
  },

  watch: {
    fieldValue() {
      this.onInputValueEntered(this.fieldValue);
    },

    allFormWidgetMounted() {
      if (this.allFormWidgetMounted) {
        this.isMounted = true;
        const value = this.getSelectedDropDownValue || this.dropDownSelectedValue;
        if (this.isFieldDropDown && this.isDropDownOptionIsValid(value)) {
          this.calledDropDownSelectMethodManually = true;
          this.onDropDownSelected(value);
        }
      }
    },

    // this is called for updating master data from server
    dropDownOptions() {
      if (!this.calledDropDownSelectMethodManually) {
        if (EzUtils.isNotEmpty(this.dropDownOptions)) {
          const value = this.getSelectedDropDownValue || this.dropDownSelectedValue;
          if (this.isFieldDropDown && this.isDropDownOptionIsValid(value)) {
            this.calledDropDownSelectMethodManually = true;
            this.onDropDownSelected(value);
          }
        }
      }
    }
  },

  mounted() {
    this.$emit("onFormWidgetMounted");
  }
};
</script>

<style
    scoped
    src="../../assets/style/base.css"></style>
